// Freebie funnel config: thank-you routing + browser-safe temporary access state.
// The secure, signed, time-limited download link returned by the backend is
// stored transiently in sessionStorage and read once on the thank-you page.
// We never turn gated PDFs into public static links.
import { CALENDLY_URL } from "@/lib/site";

export const BOOKING_URL = CALENDLY_URL; // https://calendly.com/shawnksfg/new-meeting

export const BUDGET_SHEET_COPY_URL =
  "https://docs.google.com/spreadsheets/d/1QHJko7l1qF2aWzIuP654Ib7osz8Ct89ImKOLoihZzuY/copy";
export const BUDGET_TRAINING_VIDEO_URL = "https://youtu.be/_XYxtR03hLU";
export const BUDGET_TRAINING_VIDEO_ID = "_XYxtR03hLU";

// Keyed by backend form key.
export const FREEBIES = {
  "7-steps": {
    slug: "/resources/thank-you/7-simple-steps",
    anchor: "seven-steps",
    kind: "download",
    resourceName: "7 Simple Steps to Becoming Your Own Banker",
    title: "Your 7 Simple Steps Guide Is Ready",
    blurb:
      "Thanks for requesting the 7 Simple Steps to Becoming Your Own Banker. It's a clear, practical starting point for understanding how to become your own source of financing.",
  },
  "legacy-builder": {
    slug: "/resources/thank-you/legacy-builder-outline",
    anchor: "legacy-builder",
    kind: "download",
    resourceName: "Legacy Builder Outline",
    title: "Your Legacy Builder Outline Is Ready",
    blurb:
      "Thanks for requesting the Legacy Builder Outline — a practical framework for protecting family assets, passing down values, and creating generational momentum.",
  },
  "infinite-banking-guide": {
    slug: "/resources/thank-you/infinite-banking-guide",
    anchor: "infinite-banking-guide",
    kind: "download",
    resourceName: "The Infinite Banking Guide",
    title: "Your Infinite Banking Guide Is Ready",
    blurb:
      "Thanks for requesting The Infinite Banking Guide — a clear introduction to building safe, accessible capital and becoming your own source of financing.",
  },
  "save-spend-overview": {
    slug: "/resources/thank-you/save-spend-overview",
    anchor: "save-spend-overview",
    kind: "video",
    resourceName: "Save & Spend System Overview",
    title: "Your Save & Spend System Overview Is Ready",
    blurb:
      "Thanks for requesting the Save & Spend System Overview. Watch it below to see how the system helps you organize cash flow with clarity.",
  },
  "budget-template": {
    slug: "/resources/thank-you/budget-template-training",
    anchor: "budget-template",
    kind: "budget",
    resourceName: "Budget Template + Training",
    title: "Your Budget Template and Training Are Ready",
    blurb:
      "Thanks for requesting the Budget Template + Training. Follow the steps below to get the most out of it.",
  },
};

// URL slug (last path segment) -> backend form key.
export const SLUG_TO_KEY = Object.fromEntries(
  Object.entries(FREEBIES).map(([key, f]) => [f.slug.split("/").pop(), key])
);

const storageKey = (key) => `freebie_access_${key}`;

export function storeFreebieAccess(key, data) {
  try {
    sessionStorage.setItem(storageKey(key), JSON.stringify({ ...data, ts: Date.now() }));
  } catch {
    /* sessionStorage unavailable — non-fatal */
  }
}

export function readFreebieAccess(key) {
  try {
    const raw = sessionStorage.getItem(storageKey(key));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearFreebieAccess(key) {
  try {
    sessionStorage.removeItem(storageKey(key));
  } catch {
    /* non-fatal */
  }
}
